import React, { useContext } from "react";
import clsx from "clsx";
import loadable from "@loadable/component";
import PageContext from "@PageContext";
import useSystemLinks from "@micado-digital/react-ui/hooks/useSystemLinks";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import Local from "@Local";
import localDE from "@localDE";
import localEN from "@localEN";

import styles from "./Row1.styles";

const Newsletter = loadable(() => import("./Newsletter"));
const Typography = loadable(() => import("@material-ui/core/Typography"));

const Row1 = () => {
	const [pageData] = useContext(PageContext);
	const { REACT_APP_PATH } = process.env;
	const { lang = "de" } = pageData;
	const sysLink = useSystemLinks();
	const screenSM = useMediaQuery(theme => theme.breakpoints.up("sm"));
	const css = styles();
	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN
		}
	});

	return (
		<div className={clsx(css.row1, "mco-view-component-footer-row1")}>
			<div className={clsx(css.column1, "mco-view-component-footer-row1__column1")}>
				<Typography
					className={clsx(css.headline, "mco-view-component-footer-row1__column1-headline")}
				>
					<Local identifier="footer.title" l={l} />
				</Typography>
			</div>
			<div className={clsx(css.column2, "mco-view-component-footer-row1__column2")}>
				<Newsletter
					button={
						screenSM ? (
							<Local identifier="footer.newsletterButtonLong" l={l} />
						) : (
							<Local identifier="footer.newsletterButtonShort" l={l} />
						)
					}
					fieldName="email"
					placeholder={l("footer.newsletterPlaceholder")}
					title={<Local identifier="footer.newsletterTitle" l={l} />}
					url={REACT_APP_PATH + sysLink("newsletter")}
				/>
			</div>
		</div>
	);
};

export default Row1;
